export const puzzleSizeX = 8;
export const puzzleSizeY = 8;
export const puzzleSize = puzzleSizeX * puzzleSizeY;
